module.exports = __webpack_public_path__ + "img/promocion.cb99925e.png";